import React from 'react';

import GIF_SOURCE from '../assets/img/iabilet-error.gif';

const NotFound = () => (
    <div className='mt-5 text-center'>
        <img src={GIF_SOURCE} alt='Not Found' />
        <h2 className='mb-5'>Aceasta pagina nu exista</h2>
    </div>
);

export default NotFound;
